import api from './api';

const registrationConfigService = {
  // Get system field and section definitions catalog
  getDefinitions: async () => {
    const response = await api.get('/registration-config/definitions');
    return response.data;
  },

  // Get effective configuration resolved for a specific centre / lab
  getEffectiveConfig: async (centreId = 1, orgId = null) => {
    const params = { centreId };
    if (orgId) params.orgId = orgId;
    const response = await api.get('/registration-config/effective', { params });
    return response.data;
  },

  // Get explicit centre field overrides
  getCentreOverrides: async (centreId) => {
    const response = await api.get(`/registration-config/centre/${centreId}`);
    return response.data;
  },

  // Save configuration overrides for a centre / lab
  saveConfiguration: async (centreId, payload) => {
    const response = await api.post(`/registration-config/centre/${centreId}`, payload);
    return response.data;
  },

  // Reset centre configuration back to defaults
  resetToDefault: async (centreId) => {
    const response = await api.post(`/registration-config/centre/${centreId}/reset`);
    return response.data;
  },

  // Get configuration audit logs
  getAuditLogs: async (centreId = null, pageSize = 50) => {
    const params = { pageSize };
    if (centreId) params.centreId = centreId;
    const response = await api.get('/registration-config/audit', { params });
    return response.data;
  },
};

export default registrationConfigService;
